<mat-dialog-content class="dialog-content">
  <section>
    @if (epdSectionSchema) {
      <div
        (formValueChanged)="epdFormValueChanged($event)"
        [lines]="epdSectionSchema?.lines"
        [schema]="[epdSectionSchema]"
        mdsFormSchema
      ></div>
    }
  </section>
</mat-dialog-content>
<mat-dialog-actions align="end" class="footer">
  <mds-button [type]="'primary'" (click)="submitEpdForm()" [disabled]="!epdSectionSchema.isUpdated" aria-label="Update">
    Update
  </mds-button>
</mat-dialog-actions>
